import "./CampaignTypes.css";
import { HypexLogo } from "../IconsImport";

const CampaignTypes = () => {
  return (
    <section id="hypex-section" className="campaign-types">
      <div className="campaign-types__content">

        <div className="campaign-types__eyebrow">
          <span className="campaign-types__dot"></span>
          Coming Soon To Delhi NCR
        </div>

        <h2 className="campaign-types__title">
          HYPEX- Where Creators,
          <br />
          Music &amp; Culture Collide
        </h2>

        <p className="campaign-types__description">
          A premium creator-led festival experience bringing together music,
          creators, meet &amp; greets,
          <br />
          food, brand stalls, games, fan moments, and youth culture in Delhi NCR.
        </p>

       <div className="campaign-types__media">
  <img
    src={HypexLogo}
    alt="HypeX event"
    className="campaign-types__image"
  />

  <a
    href="https://www.instagram.com/reel/DbH8WuJB3X7/"
    target="_blank"
    rel="noopener noreferrer"
    className="campaign-types__play"
    aria-label="Watch HypeX event video"
  >
    <span></span>
  </a>
</div>

        <a
          href="https://hypex.events/"
          target="_blank"
          rel="noopener noreferrer"
          className="campaign-types__button"
        >
          Know More
          <span>↗</span>
        </a>

      </div>
    </section>
  );
};

export default CampaignTypes;